import React, { useState } from "react";
import logo from '../../assets/logo.jpeg';  
import { Link, useNavigate } from "react-router-dom";
import { requestPasswordReset } from "../../api/reset-auth-api";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
   const navigate = useNavigate(); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      const res = await requestPasswordReset(email);
      setMessage(res.message || "Check your email for reset code");
      navigate('/verify-token', { state: { email } });
    } catch (err) {
      setError(err.message || "Failed to send reset link");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white p-8 shadow-md rounded">
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Hold the Child" className="h-16" />
        </div>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">Password Reset</h2>
        <p className="text-sm text-gray-600 mb-4">
          Provide the email address associated with your account to recover your password.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-orange-400 mb-4"
            placeholder="name@example.com"
            required
          />
          <button
            type="submit"
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded"
          >
            Submit
          </button>
          {message && <p className="text-green-600 mt-4">{message}</p>}
          {error && <p className="text-red-600 mt-4">{error}</p>}
        </form>

       
        <div className="mt-6 text-center">
          <Link to="/" className="text-sm text-gray-500 hover:underline">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
